function CompanyLogoWhite() {
  return (
    <svg
      width="113"
      height="113"
      viewBox="0 0 113 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M72.2635 40.1038C69.0204 40.1829 43.0078 41.0756 43.0078 41.0756L43.1773 41.4993H46.8611L43.2677 41.7253L43.3242 41.8722C43.3242 41.8722 60.4098 41.7762 61.6754 41.5615C62.941 41.3524 63.167 41.0925 63.167 41.0925C63.167 41.0925 75.3371 40.7874 77.9135 39.3862C77.9305 39.3919 75.5123 40.0247 72.2635 40.1038Z"
        fill="url(#paint0_linear_19_278)"
      />
      <path
        d="M18.967 45.1492C15.8538 45.895 14.7351 48.0759 14.7351 48.0759C14.7351 48.0759 16.3906 45.7029 20.7524 45.4882C25.1142 45.2791 37.1543 45.0644 37.1543 45.0644C37.1543 45.0644 22.0801 44.4034 18.967 45.1492Z"
        fill="url(#paint1_linear_19_278)"
      />
      <path
        d="M94.0724 45.1492C97.1855 45.895 98.3042 48.0759 98.3042 48.0759C98.3042 48.0759 96.6488 45.7029 92.287 45.4882C87.9252 45.2791 75.885 45.0644 75.885 45.0644C75.885 45.0644 90.9536 44.4034 94.0724 45.1492Z"
        fill="url(#paint2_linear_19_278)"
      />
      <path
        d="M67.6418 32.5271C55.3756 31.7022 49.703 33.7419 45.2282 35.3521C40.7478 36.9567 36.8323 40.2902 32.7417 40.923C28.6511 41.5558 17.6675 41.3807 13.3227 42.6745C11.6503 43.1717 10.5655 43.5559 9.93833 43.7932C9.57673 43.9288 9.42983 44.3695 9.64453 44.6972C9.64453 44.6972 11.9554 43.3073 17.0404 42.6519C22.1254 41.9965 26.6115 42.2621 26.6115 42.2621C26.6115 42.2621 16.7296 42.7649 13.8594 43.9006C12.3339 44.5051 11.4356 44.8724 10.9214 45.2114C10.5711 45.443 10.4694 45.912 10.6954 46.2679C10.6954 46.2679 13.334 44.1435 17.9274 43.7367C21.7694 43.3977 34.6966 43.2282 38.8211 43.183C39.5952 43.1717 40.3127 42.7875 40.7478 42.1491C41.228 41.4428 41.8721 40.601 42.3128 40.3806C42.3128 40.3806 43.0417 40.3806 43.5615 40.3806C44.0813 40.3806 45.1661 39.7309 45.2169 39.584C45.2678 39.4371 44.5672 38.7082 43.8892 38.6404C43.4202 38.5952 41.9851 40.1094 41.1263 41.0643H38.4256L40.2393 39.4936L36.708 41.5332H40.7082C40.5444 41.7197 40.4483 41.8327 40.4483 41.8327L34.6288 41.7705C34.3463 41.7649 34.2955 41.3637 34.5667 41.2903C35.3294 41.0869 36.1261 40.8496 36.5555 40.6631C37.5103 40.2394 45.9175 34.821 56.839 33.9114C62.8788 33.4085 68.8904 33.9735 73.0771 34.6176C73.5065 34.6854 73.7833 35.1035 73.6873 35.5216L72.6985 39.7309L74.6817 35.3521C74.8003 35.0979 75.0772 34.951 75.354 35.0018C76.5518 35.2222 77.4784 35.4256 78.066 35.5838C80.6481 36.2674 80.8402 36.5217 80.4277 37.3748C80.0153 38.228 79.2695 38.8325 79.2695 38.8325C79.2695 38.8325 80.3995 38.2958 81.4617 37.0189C81.4617 37.0189 91.5469 39.5162 91.4283 39.7422C91.304 39.9738 80.2356 40.132 78.5519 40.5953C76.8739 41.0586 75.8738 42.6011 75.8738 42.6011C75.8738 42.6011 83.4335 41.601 89.5525 41.8722C95.6714 42.1491 97.6998 42.618 98.2987 42.4881C98.8976 42.3581 99.4682 41.7762 99.4682 41.7762C99.4682 41.7762 100.412 42.0982 101.141 41.94C101.869 41.7762 102.276 41.0643 102.276 41.0643C102.276 41.0643 79.9079 33.3577 67.6418 32.5271ZM96.4963 41.8214C95.0047 41.5615 85.3432 40.7083 85.3432 40.7083C88.2643 40.4993 98.3043 41.2451 98.3043 41.2451C98.3043 41.2451 97.9879 42.0813 96.4963 41.8214Z"
        fill="url(#paint3_linear_19_278)"
      />
      <path
        d="M44.1716 37.8607C44.1716 37.8607 51.6466 34.5103 59.2571 34.5103C66.8677 34.5103 72.8736 35.2787 72.8736 35.2787L71.7888 38.3523L44.1716 37.8607Z"
        fill="url(#paint4_linear_19_278)"
      />
      <path
        d="M74.7156 36.3407L73.7947 38.612C73.7947 38.612 78.2412 38.7872 78.9418 38.403C79.6424 38.0188 80.0718 37.1713 79.9193 36.8888C79.8006 36.6741 76.9643 36.0978 75.6422 35.8435C75.2524 35.7644 74.8682 35.9735 74.7156 36.3407Z"
        fill="url(#paint5_linear_19_278)"
      />
      <path
        d="M19.2609 48.6692V51.0026H11.8425V52.5225H19.0801V54.8729H11.8425V58.9465H8.63892V48.6692H19.2609Z"
        fill="white"
      />
      <path
        d="M28.7246 57.0707H22.4926L21.566 58.9465H18.2947L23.487 48.6692H27.6567L33.1542 58.9465H29.6851L28.7246 57.0707ZM25.5436 50.8953L23.6396 54.7486H27.5324L25.5436 50.8953Z"
        fill="white"
      />
      <path
        d="M38.8326 59.1272C33.4482 59.1272 32.8267 56.805 32.8267 55.4547V55.3021H36.1828C36.2223 55.9236 36.5839 56.9293 39.2338 56.9293H39.4259C42.1322 56.9293 42.4373 56.3926 42.4373 55.8389C42.4373 55.2456 42.1209 54.8727 39.7423 54.8049L37.9738 54.7654C34.1318 54.6524 32.9623 53.3585 32.9623 51.7539V51.6296C32.9623 50.0985 33.8719 48.4939 38.5558 48.4939H39.5106C44.3696 48.4939 45.477 50.1945 45.477 51.737V51.8726H42.1322C42.0644 51.4884 41.8554 50.6409 39.1603 50.6409H38.94C36.454 50.6409 36.2732 51.0816 36.2732 51.5223C36.2732 51.963 36.55 52.3641 38.6462 52.4037L40.3751 52.4319C44.2397 52.4997 45.8047 53.4376 45.8047 55.4829V55.675C45.8047 57.3757 44.9459 59.1159 39.7818 59.1159H38.8326V59.1272Z"
        fill="white"
      />
      <path
        d="M50.6129 51.1043H46.1946V48.6748H58.2912V51.1043H53.856V58.9465H50.6129V51.1043Z"
        fill="white"
      />
      <path
        d="M70.1844 59.1272C64.2293 59.1272 63.3083 55.7994 63.3083 53.9744V53.5733C63.3083 51.7088 64.1106 48.4883 70.1844 48.4883H70.7494C76.7045 48.4883 77.6255 51.3359 77.6255 52.5337V52.6862H74.2128C74.1281 52.4094 73.7156 50.9743 70.4556 50.9743C67.3763 50.9743 66.6701 52.3529 66.6701 53.6411V53.8049C66.6701 55.0197 67.4837 56.6243 70.4838 56.6243C73.8117 56.6243 74.145 55.0366 74.2241 54.7993H77.6367V54.9519C77.6367 56.2514 76.6141 59.1216 70.7437 59.1216H70.1844V59.1272Z"
        fill="white"
      />
      <path
        d="M87.5129 57.0707H81.2866L80.36 58.9465H77.0886L82.281 48.6692H86.4507L91.9481 58.9465H88.479L87.5129 57.0707ZM84.3376 50.8953L82.4335 54.7486H86.3264L84.3376 50.8953Z"
        fill="white"
      />
      <path
        d="M95.7337 58.9465H92.5132V48.6692H100.802C104.226 48.6692 105.265 49.8557 105.265 51.336V51.4998C105.265 52.9801 104.034 53.5282 103.361 53.7485C104.412 54.0536 105.31 54.7825 105.31 56.1102V57.6131C105.31 58.4437 105.406 58.7036 105.503 58.8674V58.9352H102.231C102.135 58.8109 102.079 58.6584 102.079 58.2855V57.099C102.079 55.8447 101.525 55.291 99.9373 55.291H95.7393V58.9465H95.7337ZM95.7337 53.0197H100.61C101.536 53.0197 101.909 52.579 101.909 52.014V52.0027C101.909 51.4659 101.548 51.0083 100.61 51.0083H95.7337V53.0197Z"
        fill="white"
      />
      <path
        d="M24.9674 77.9304C32.7475 77.9304 34.6346 75.3088 35.2165 72.7493L35.2843 72.4555C35.9849 69.3763 33.9566 67.9638 28.1597 67.8564L25.572 67.8169C22.4249 67.7547 22.1481 67.1502 22.3006 66.4835C22.4532 65.8168 22.8769 65.1501 26.6172 65.1501H26.9506C31.0073 65.1501 31.0299 66.4213 31.0016 67.0033H36.0358L36.081 66.7942C36.6121 64.4664 35.5273 61.907 28.2105 61.907H26.7754C19.7242 61.907 17.8032 64.3195 17.2778 66.6304L17.2326 66.8168C16.6845 69.2294 18.0066 71.1843 23.7527 71.3481L26.4025 71.4103C29.9564 71.512 30.3067 72.077 30.1033 72.9697C29.9112 73.8002 29.2727 74.6138 25.1934 74.6138H24.8996C20.9051 74.6138 20.713 73.094 20.8599 72.1617H15.8031L15.7523 72.3877C15.289 74.4274 15.4302 77.9191 23.538 77.9191L24.9674 77.9304ZM49.0929 71.3368H43.2282L47.4205 65.5343L49.0929 71.3368ZM50.9009 77.6592H56.1215L51.3699 62.1838H45.0814L33.7362 77.6592H38.663L40.7027 74.8285H50.0817L50.9009 77.6592ZM60.4946 62.1838L56.969 77.6592H72.5687L73.4444 73.8115H62.6925L65.3423 62.1838H60.4946ZM77.8797 62.1838L74.3541 77.6592H90.869L91.6883 74.0601H79.9589L80.5352 71.5233H91.7843L92.5923 67.9864H81.3375L81.8573 65.6981H93.3776L94.1799 62.1838C94.1856 62.1838 77.8797 62.1838 77.8797 62.1838Z"
        fill="url(#paint6_linear_19_278)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19_278"
          x1="7.43221"
          y1="40.6329"
          x2="103.037"
          y2="40.6329"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00140224" stopColor="#97272D" />
          <stop offset="0.9987" stopColor="#ED1C24" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19_278"
          x1="7.43204"
          y1="46.438"
          x2="103.037"
          y2="46.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00140224" stopColor="#97272D" />
          <stop offset="0.9987" stopColor="#ED1C24" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_19_278"
          x1="105.607"
          y1="46.438"
          x2="10.002"
          y2="46.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00140224" stopColor="#97272D" />
          <stop offset="0.9987" stopColor="#ED1C24" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_19_278"
          x1="7.43213"
          y1="39.3047"
          x2="103.038"
          y2="39.3047"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00140224" stopColor="#97272D" />
          <stop offset="0.9987" stopColor="#ED1C24" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_19_278"
          x1="58.5257"
          y1="33.9168"
          x2="58.5257"
          y2="37.2781"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#959DAE" />
          <stop offset="1" stopColor="#959DAE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_19_278"
          x1="76.8744"
          y1="35.7326"
          x2="76.8744"
          y2="37.9326"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#959DAE" />
          <stop offset="1" stopColor="#959DAE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_19_278"
          x1="67.892"
          y1="90.9242"
          x2="43.8938"
          y2="49.358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2F2F2" />
          <stop offset="0.1693" stopColor="#808080" />
          <stop offset="0.4457" stopColor="white" />
          <stop offset="0.8051" stopColor="#716E6F" />
          <stop offset="1" stopColor="#F2F2F2" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CompanyLogoWhite;
